module.exports = __webpack_public_path__ + "static/sinaran-logo-2-8e7eb58c3243851e1a820dfaf5b88a3a.png";